import React from 'react'
import './TopBar.css'

const TopBar = (props) => {
    return (
        <div className="top-bar-container">
            {
                props.showed ?
                    <svg width="22" height="22" viewBox="0 0 22 22" onClick={props.openSettings}>
                        <rect y="17.6777" width="25" height="6" rx="2" transform="rotate(-45 0 17.6777)" fill="#170000" />
                        <rect x="4.24268" width="25" height="6" rx="2" transform="rotate(45 4.24268 0)" fill="#170000" />
                    </svg> :
                    <svg width="25" height="24" viewBox="0 0 25 24" onClick={props.openSettings}>
                        <rect width="25" height="6" rx="2" fill="#170000" />
                        <rect y="9" width="20" height="6" rx="2" fill="#170000" />
                        <rect y="18" width="25" height="6" rx="2" fill="#170000" />
                    </svg>

            }


            <div className="top-bar-label-container">
                <p className="label">Schulte Table</p>
                <p className="secondary-label">Improve fast reading & attention</p>
            </div>
        </div>
    )
}

export default TopBar
